import React from "react";
import { ChatLoader, ChatMessagesWrapper } from "@features/chat/desktop";

export default function ChatContent() {
	return (
		<>
			<ChatLoader />
			<div className="chat__box">
				<ChatMessagesWrapper />
			</div>
		</>
	);
}
